import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum AddressValidationSecurityRight {
    CanAccess = 32000
}

export class AddressValidationSecurityModule extends BaseSecurityModule<AddressValidationSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.AddressValidation,
            [
                { _id: AddressValidationSecurityRight.CanAccess, name: 'Access', basic: true },
            ] as SecurityRight<AddressValidationSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }


}